import { AxisLabelsFormatterContextObject } from "highcharts";
import { ChartBaseType } from "../../../../../services/cloudchipr.api";
import { moneyFormatter } from "../../../../../utils/numeral/moneyFormatter";

export const getHighChartsYAxisLabelsFormatter =
  (chartBase: ChartBaseType) => (params: AxisLabelsFormatterContextObject) => {
    return chartBase === "cost"
      ? `${moneyFormatter(+params.value)}`
      : `${+params.value}%`;
  };
